import { render, staticRenderFns } from "./dialogFormItems.vue?vue&type=template&id=2dc47534&scoped=true&"
import script from "./dialogFormItems.vue?vue&type=script&lang=js&"
export * from "./dialogFormItems.vue?vue&type=script&lang=js&"
import style0 from "./dialogFormItems.vue?vue&type=style&index=0&id=2dc47534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc47534",
  null
  
)

export default component.exports